module.exports = __webpack_public_path__ + "img/cinema_1.bce5e973.jpg";